<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors  : 陈钊贤
 * @Description:
 * @LastEditTime : 2020-01-14 17:54:11
 -->
<template>
  <pi-content className="white">
    <div class="success-box">
      <div class="success-icon">
        <img src="@/assets/img/cash-success.png"
             alt=""
             class="wh100">
      </div>
      <div class="title">退款申请成功</div>
      <div class="cash-text"
           v-if="refundType==1">审核成功后，预计0-5个工作日退还至原支付账户，请注意查收。</div>
      <div class="cash-text"
           v-else>预计0-5个工作日退还至原支付账户，请注意查收。</div>
      <div style="box-sizing: border-box; padding: 0 0.6rem">
        <pi-button type="primary"
                   block
                   @click="close">完成</pi-button>
      </div>

    </div>
  </pi-content>
</template>
<script>
export default {
  name: 'my-cash-success',
  data () {
    return {
      refundType: ''
    };
  },
  created () {
    let refundType = this.$common.query('refundType');
    this.refundType = refundType;
  },
  methods: {
    close () {
      history.go(-2);
    }
  }
};
</script>
<style lang="less" scoped>
.success-box {
  padding-top: 1rem;
  text-align: center;
  .success-icon {
    width: 3.49rem;
    height: 4.93rem;
    margin: auto;
  }
  .title {
    margin-top: 0.44rem;
    font-size: 0.38rem;
    color: #333333;
  }
  .cash-text {
    margin-top: 0.3rem;
    padding: 0 1.12rem;
    font-size: 0.24rem;;
    color: #999;
    margin-bottom: 0.5rem;
  }
}
</style>
